import moment from "moment";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReCAPTCHA from "react-google-recaptcha";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useDynamicRefs from "use-dynamic-refs";
import {
  captchaChecked,
  formData,
  MyLibraryLogInAsync,
  myLibs,
  pagesState,
  validateNumber,
} from "./controller";

export function SchoolForm() {
  const dispatch = useDispatch();
  const pages_state = useSelector(pagesState);
  const my_Libs = useSelector(myLibs);
  const form_Data = useSelector(formData);

  const [getRef, setRef] = useDynamicRefs();

  const [startDate, setStartDate] = useState(
    form_Data ? new Date(form_Data.BirthDate) : new Date()
  );
  const [dateChanged, setDateChanged] = useState(false);

  const toggleDateChange = (date) => {
    setStartDate(date);
    setDateChanged(dateChanged);
  };

  useEffect(() => {
    if (!sessionStorage.getItem("sdc")) {
      // window.location.href = "./school/disclaimer";
    }

    const redirectUrl = {
      CallBackUrl: process.env.REACT_APP_SCHOOL_CALLBACKURL,
    };
    dispatch(MyLibraryLogInAsync(redirectUrl));
  }, []);

  const submitRequest = (e) => {
    e.preventDefault();

    if (getRef("recaptcha").current.getValue() &&
      pages_state.isNumberCorrect &&
      pages_state.isDateWithin3Years
    ) {
      var formData = {
        RequestorName: getRef("name").current.value,
        RequestorEmail: getRef("email").current.value,
        // requestorInternationCode: getRef("firstNo").current.value,
        RequestorMobile: getRef("lastNo").current.value,
        SchoolName: getRef("schoolAttended").current.value,
        // "BirthDate": getRef('dateofBirth').current.value,
        BirthDate: moment(startDate).format("YYYY-MM-DD"),
        //SearchFromYear: getRef("yearofStudyStart").current.value,
        //SearchToYear: getRef("yearofStudyEnd").current.value,
        SearchFromYear: studyStartDate ? studyStartDate.getFullYear() : '',
        SearchToYear: studyEndDate ? studyEndDate.getFullYear() : '',
        Remarks: getRef("remarks").current.value,
      };
      sessionStorage.setItem("sfs", JSON.stringify(formData));
      dispatch(captchaChecked(true));
      setTimeout(() => {
        window.location.href = "./school/summary";
      }, 500);
    } else if (!getRef("recaptcha").current.getValue()) {
      dispatch(captchaChecked(false));
    }
  };

  const verifyNumber = (e) => {
    if (e.target.value.length < 8) {
      dispatch(validateNumber(false));
    } else {
      dispatch(validateNumber(true));
    }
  };

  const triggerForm = () => {
    window.wogaaCustom && window.wogaaCustom.startTransactionalService('ArchivesOnline-2859');
  }

  const [studyStartDate, setStudyStartDate] = useState(
    form_Data?.SearchFromYear ? new Date(form_Data.SearchFromYear, 0) : null
  );
  const [studyEndDate, setStudyEndDate] = useState(
    form_Data?.SearchToYear ? new Date(form_Data.SearchToYear, 0) : null
  );

  return (
    <section id="SchoolDisForm">
      <div className="container-fluid mt-3 form">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <img src="./images/icn-OnTopSchool.png" alt="" />
                <h2 className="pageTitle mt-2">School Record</h2>
                <div className="step">
                  <div className="breadcrumbs">
                    <ul className="steps d-flex justify-content-center align-items-center">
                      <li>
                        <img src="./images/icon-form.png" alt="Step 1" />
                        <span>
                          <b>Form</b>
                        </span>
                      </li>
                      <li>
                        <img
                          src="./images/icon-complete-disabled.png"
                          alt="Step 2"
                        />
                        <span className="text-gray">Complete</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <form onSubmit={(e) => submitRequest(e)}>
                <div className="card overflow-hidden">
                  <div className="card-header"></div>
                  <div className="card-body d-flex justify-content-center">
                    <div className="entryForm">
                      {my_Libs && !my_Libs.isMylibsLogin && (
                        <div className="mylibs mb-5">
                          <div className="theme-color fw-bold text-center">
                            Click here to login with your Mylibrary ID Account
                            to retrieve your information. If you do not have an
                            account, please fill in the form below with your
                            details.
                          </div>
                          <div className="d-flex justify-content-center mt-3">
                            <a
                              className="ui-theme-btn btn-mylibrary cursor_pointer"
                              title="Login using your NLB account."
                              target="_self"
                              href={pages_state ? pages_state.dataUrl : "#"}
                            >
                              <img
                                style={{ maxHeight: "31px", width: "auto" }}
                                src="./images/nlb-logo-white.svg"
                                alt=""
                              />{" "}
                              <span className="px-1">NLB myLibrary</span>{" "}
                              <span
                                style={{ fontSize: "20px" }}
                                className="material-icons-outlined align-middle"
                              >
                                chevron_right
                              </span>{" "}
                            </a>
                          </div>
                        </div>
                      )}

                      <div className="mt-5">
                        <h3 className="theme-color text-center">
                          Requestor's Particulars
                        </h3>

                        <div className="mb-3 row mt-3">
                          <label
                            htmlFor="name"
                            className="col-sm-2 col-form-label text-nowrap"
                          >
                            Name<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              className="form-control"
                              defaultValue={
                                form_Data
                                  ? form_Data.RequestorName
                                  : my_Libs
                                  ? my_Libs.RequestorNameFromLibs
                                  : ""
                              }
                              id="name"
                              ref={setRef("name")}
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label
                            htmlFor="email"
                            className="col-sm-2 col-form-label text-nowrap"
                          >
                            Email<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="email"
                              className="form-control"
                              defaultValue={
                                form_Data
                                  ? form_Data.RequestorEmail
                                  : my_Libs
                                  ? my_Libs.RequestorEmailFromLibs
                                  : ""
                              }
                              ref={setRef("email")}
                              id="email"
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label
                            htmlFor="LastNo"
                            className="col-sm-2 col-form-label text-nowrap"
                          >
                            Mobile No<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-10 d-flex flex-row">
                            <div className="me-3">
                              <select
                                id="firstNo"
                                className="form-control"
                                ref={setRef("firstNo")}
                                defaultValue={
                                  form_Data
                                    ? form_Data.requestorInternationCode
                                    : ""
                                }
                              >
                                <option value="+65">+65</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                            <div style={{ flexBasis: "100%" }}>
                              <input
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                defaultValue={
                                  form_Data
                                    ? form_Data.RequestorMobile
                                    : my_Libs
                                    ? my_Libs.RequestorMobileFromLibs
                                    : ""
                                }
                                className={
                                  pages_state && pages_state.isNumberCorrect
                                    ? "form-control w-100"
                                    : "form-control w-100 is-invalid"
                                }
                                id="lastNo"
                                autoComplete="off"
                                onBlur={(e) => verifyNumber(e)}
                                ref={setRef("lastNo")}
                                required
                              />
                              {pages_state && !pages_state.isNumberCorrect && (
                                <div className="text-danger ">
                                  <small> At least 8 digits!</small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card overflow-hidden mt-3">
                  <div className="card-header"></div>
                  <div className="card-body d-flex justify-content-center">
                    <div className="entryForm">
                      <div>
                        <h3 className="theme-color text-center">
                          School Particulars
                        </h3>

                        <div className="mb-3 row mt-3">
                          <label
                            htmlFor="SchoolAttended"
                            className="col-sm-2 col-form-label text-wrap"
                          >
                            School Attended
                            <span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-10">
                            <input
                              type="text"
                              defaultValue={
                                form_Data ? form_Data.SchoolName : ""
                              }
                              className="form-control"
                              id="SchoolAttended"
                              ref={setRef("schoolAttended")}
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label
                            htmlFor="DateofBirth"
                            className="col-sm-2 col-form-label text-wrap"
                          >
                            Date of Birth<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-10">
                            {/* <input type="date" defaultValue={form_Data ? form_Data.BirthDate : ''} min={'1900-01-01'} max={moment().format('YYYY-MM-DD')} className="form-control" id="DateofBirth" ref={setRef('dateofBirth')} required /> */}

                            <DatePicker
                              selected={startDate}
                              onChange={(date) => toggleDateChange(date)}
                              closeOnScroll={true}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control"
                              dateFormat="dd/MM/yyyy"
                              minDate={new Date("1900-01-01")}
                              maxDate={new Date()}
                              placeholderText="dd/mm/yyyy"
                              required
                            />
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label
                            htmlFor="YearofStudyEnd"
                            className="col-sm-2 col-form-label text-wrap"
                          >
                            Year of Study<span className="text-danger">*</span>:
                          </label>
                          <div className="col-sm-10 d-flex flex-row">
                          <div className="me-3" style={{ flexBasis: "100%" }}>
                            <DatePicker
                              selected={studyStartDate}
                              onChange={(date) => setStudyStartDate(date)}
                              showYearPicker
                              dateFormat="yyyy"
                              minDate={new Date(1912, 0, 1)}
                              maxDate={new Date(1981, 11, 31)}
                              filterDate={(date) => date.getFullYear() <= 1981}
                              placeholderText="Select start year"
                              className="form-control"
                              required
                            />
                          </div>
                          <div className="me-3 d-flex align-items-center">
                            <span>to:</span>
                          </div>
                          <div style={{ flexBasis: "100%" }}>
                            <DatePicker
                              selected={studyEndDate}
                              onChange={(date) => setStudyEndDate(date)}
                              showYearPicker
                              dateFormat="yyyy"
                              minDate={new Date(1912, 0, 1)}
                              maxDate={new Date(1981, 11, 31)}
                              filterDate={(date) => date.getFullYear() <= 1981}
                              placeholderText="Select end year"
                              className="form-control"
                              required
                              />
                            </div>
                          </div>
                          <div className="col-sm-10 offset-sm-2 mt-1">
                            <span className="material-icons-outlined align-middle me-1">
                              error_outline
                            </span>
                            <small>
                              For school records from 1982 onwards, please contact the Ministry of Education. More details <a className="fw-bold" href="https://form.gov.sg/5d0b535fe6ca2a00111f3868">here</a>.
                            </small>
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label
                            htmlFor="remarks"
                            className="col-sm-2 col-form-label text-nowrap"
                          >
                            Remarks:
                          </label>
                          <div className="col-sm-10">
                            <textarea
                              placeholder="Tell us more to help us search (eg. Level entered, transfers, highest standard attended, any repeated level)"
                              className="form-control"
                              defaultValue={form_Data ? form_Data.Remarks : ""}
                              rows="5"
                              id="remarks"
                              ref={setRef("remarks")}
                            ></textarea>
                          </div>
                        </div>
                        {/* {process.env.REACT_APP_USERECAPTCHA === "true" && ( */}
                          <div className="mb-3 row mt-4">
                            <div className="col-sm-12 d-flex justify-content-center">
                              <ReCAPTCHA
                                sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                                ref={setRef("recaptcha")}
                              />
                            </div>
                            <div className="col-sm-12 d-flex justify-content-center">
                              {pages_state && !pages_state.isCaptcha && (
                                <div className="text-danger ">
                                  <small> Recaptcha is required!</small>
                                </div>
                              )}
                            </div>
                          </div>
                        {/* )} */}
                        <div className="mb-3 row">
                          <div className="col-sm-12 d-flex justify-content-center">
                            <button
                              type="submit"
                              className="btn btn-primary btn-lg me-2"
                              onClick={triggerForm}
                            >
                              Submit
                            </button>
                            <Link to={"/"} className="btn btn-secondary btn-lg">
                              Cancel
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
